import { combineReducers } from "redux";

import { packageDetails } from "./reducer.package"
const packageReducers = combineReducers({
    packageDetails
})
export default packageReducers;
